import { render } from "./App.vue?vue&type=template&id=2296bce1"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2296bce1&lang=scss"

import exportComponent from "D:\\Projects\\attituttu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__